import { get } from 'lodash-es';
import { isSpinCar360Enabled } from 'site-modules/shared/utils/inventory/is-spin-car-360-enabled';
import { isCarMax360Enabled } from 'site-modules/shared/utils/inventory/is-car-max-360-enabled';
import { isPartnerDealer } from 'site-modules/shared/utils/dealer-details-utils';
import { CARMAX, PROVIDER_360, SPINCAR } from 'site-modules/shared/constants/providers-360';

/**
 * Get photo 360 object from vinData
 * @param {object} vinData
 * @param {boolean} doNotSell
 * @param {boolean} isBLT2125DisableCarmax360
 * @param {boolean} isBLT2125DisableSpinCar360
 * @param {boolean} isSHOP413DisableFlickFusion360
 * @return {Object} object with photo info, tracking and photo provider
 */
export function getPhoto360({
  vinData,
  doNotSell,
  isBLT2125DisableCarmax360,
  isBLT2125DisableSpinCar360,
  isSHOP413DisableFlickFusion360,
}) {
  const isSpinCarEligible = isSpinCar360Enabled(vinData, doNotSell, isBLT2125DisableSpinCar360);
  const inventoryPhoto360 = get(vinData, 'vehicleInfo.photo.photo360');

  if (inventoryPhoto360) {
    if (isCarMax360Enabled(vinData, isBLT2125DisableCarmax360)) {
      return { provider: CARMAX, ...get(inventoryPhoto360, CARMAX) };
    } else if (isSpinCarEligible) {
      return {
        provider: SPINCAR,
        ...get(inventoryPhoto360, SPINCAR),
        ...PROVIDER_360[SPINCAR].tracking,
      };
    } else if (!isSHOP413DisableFlickFusion360 && isPartnerDealer(vinData)) {
      const filteredPhoto360 = Object.entries(inventoryPhoto360).filter(
        ([provider, photoInfo]) =>
          ![CARMAX, SPINCAR].includes(provider) &&
          (get(photoInfo, 'hasExterior', false) || get(photoInfo, 'hasInterior', false)) &&
          get(photoInfo, 'extIntUrl')
      );
      if (filteredPhoto360.length) {
        const [provider, photoInfo] = filteredPhoto360[0];
        if (PROVIDER_360[provider]) {
          return { provider, ...photoInfo, ...PROVIDER_360[provider].tracking };
        }
      }
    }
  }
  return null;
}
